<template>
  <div :class="{ main: meal.depth === 1, 'col-md-12': meal.depth === 1 }">
    <div class="row" :style="styleObject">
      <div class="col-md-4" >
        <div>
          <label class="mt-checkbox mt-checkbox-outline">
            {{ meal.kind }} - {{ meal.mealWorkName }}<br/>
            <p style="font-size: 11px; margin: 0">{{ meal.kind }} - {{ meal.mealName }}</p>
            <div v-if="showDetails">
              <b>Ilość:</b> {{ meal.quantity }} szt<br/>
              <b>{{ 'brand.brand' | trans }}:</b> {{ meal.brands }}<br/>
              <b>{{ 'size.sizes' | trans }}:</b> {{ meal.sizes }}<br/>
              <b>{{ 'meal.entity.types' | trans }}:</b> {{ meal.types }}
            </div>
            <input
                ref="checkboxMeal"
                :value="meal.mealId"
                :checked="isChecked"
                :disabled="disabled"
                type="checkbox"
                @click="$emit('check', meal.mealId)"
            />
            <span></span>
          </label>
        </div>
      </div>
      <div class="col-md-1">
        <span
            v-show="isDifferentTeam || isDifferentDate"
            v-tooltip.left="'PS jest przypisany na inną zmianę'"
            class="fa fa-arrow-left text-info">
        </span>
        <span
            v-show="!isTouched && meal.isGenerated"
            v-tooltip.left="'Wpis został wygenerowany przez automat'"
            class="fa fa-cog text-info">
        </span>
        <div class="row">
          <a
              :href="'/meal/update/' + meal.mealId"
              target="_blank"
              class="link-edit-pk fa fa-pencil-square-o text-info"
              v-tooltip.left="'Przejdź do edycji posiłku'">
          </a>
        </div>
      </div>
      <div class="col-md-7">
        <div class="row">
          <div class="col-md-2">
            <date-picker
                ref="productionDate"
                :value="productionDate"
                :time="false"
                :init-value="false"
                :disabled="disabled"
                can-clear
                placeholder="Wybierz datę"
                @input="changeDate"
                @clear="clearDate"
            />
          </div>
          <div class="col-md-2">
            <new-single-select
                v-model="hour"
                :options="hours"
                :disabled="disabled"
                placeholder="godzina"
            />
          </div>
          <div class="col-md-4">
            <new-single-select
                v-model="teamId"
                :options="teams"
                :disabled="disabled"
                placeholder="zespół produkcyjny"
            />
          </div>
          <div class="col-md-2">
            <new-single-select
                v-model="unfoldingTeamId"
                :options="unfoldingTeams"
                :disabled="disabled"
                placeholder="rozkładanie"
                label="symbol"
            />
          </div>
        </div>
      </div>
      <div v-if="meal.depth === 1" class="col-md-12">
        <div v-show="meal.components.length > 0" class="col-md-12">
          <label class="mt-checkbox mt-checkbox-outline">
            <div class="checkbox-text">Rozwiń wszystkie</div>
            <input
                type="checkbox"
                v-model="isExpandAll"
                @click="expand"
            />
            <span></span>
          </label>
        </div>
      </div>
      <div class="col-md-12">
        <div v-show="meal.components.length > 0" class="col-md-12">
          <a v-if="!showComponents" @click="showComponents = true"><i class="fa fa-caret-down" ></i></a>
          <a v-if="showComponents"  @click="showComponents = false"><i class="fa fa-caret-up" ></i></a>
        </div>
      </div>
      <assign-team-meal-row
        v-show="showComponents"
        ref="assignTeamMealRow"
        v-for="(mealRow, index) in meal.components"
        :key="index"
        :meal="mealRow"
        :is-checked="Boolean(false)"
        :teams="teams"
        :unfolding-teams="unfoldingTeams"
        :hours="hours"
        :disabled="Boolean(false)"
        :show-details="Boolean(false)"
        @assingteam="componentsAssignTeam"
      />
    </div>
  </div>
</template>

<script>
import DatePicker from '@component/newDatePicker.vue'
import NewSingleSelect from '@component/newsingleselect.vue'
import DateHelper from '@js/helpers/dateHelper'

export default {
  name: 'AssignTeamMealRow',
  components: {
    DatePicker,
    NewSingleSelect,
  },
  props: {
    meal: {
      type: Object,
      required: true,
    },
    isChecked: {
      type: Boolean,
      required: true,
    },
    disabled: {
      type: Boolean,
      required: true,
    },
    teams: {
      type: Array,
      required: true,
    },
    hours: {
      type: Array,
      required: true,
    },
    all: {
      type: Boolean,
      required: false,
    },
    showDetails: {
      type: Boolean,
      required: true,
    },
    unfoldingTeams: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      isBlocked: false,
      isTouched: false,
      showComponents: false,
      isDifferentTeam: this.isDifferentTeamMethod(this.meal, this.meal.teamId),
      isDifferentUnfoldingTeam: this.isDifferentTeamMethod(this.meal, this.meal.unfoldingTeamId),
      isDifferentDate: this.isDifferentDateMethod(this.meal, this.meal.productionDate),
      refreshKey: 0,
      isExpandAll: false,
    }
  },
  computed: {
    styleObject: function() {
      return {
        'margin-left': `${this.meal.depth * 10}px`
      }
    },
    productionDate: {
      get: function () {
        this.refreshKey
        return this.meal.productionDate
      },
      set: function (value) {
        if (value !== this.meal.productionDate) {
          this.meal.productionDate = value

          if (this.$refs.assignTeamMealRow) {
            this.$refs.assignTeamMealRow.forEach((component) => {
              component.isBlocked = true
              component.productionDate = this.meal.productionDate
              component.isBlocked = false
            })
          }

          if (!this.isBlocked) {
            this.save('production_date')
          }

          if (this.meal.kind === 'PK') {
            this.isDifferentTeam = this.isDifferentTeamMethod(this.meal, this.meal.teamId)
            this.isDifferentUnfoldingTeam = this.isDifferentUnfoldingTeamMethod(this.meal, this.meal.unfoldingTeamId)
          }

          this.refreshKey++
          this.isTouched = true
        }
      }
    },
    teamId: {
      get: function () {
        this.refreshKey
        return this.meal.teamId
      },
      set: function (value) {
        if (value !== this.meal.teamId) {
          this.meal.teamId = value

          if (this.$refs.assignTeamMealRow) {
            this.$refs.assignTeamMealRow.forEach((component) => {
              component.isBlocked = true
              component.teamId = this.meal.teamId
              component.isBlocked = false
            })
          }

          if (!this.isBlocked) {
            this.save('team')
          }

          if (this.meal.kind === 'PK') {
            this.isDifferentTeam = this.isDifferentTeamMethod(this.meal, this.meal.teamId)
          }

          this.refreshKey++
          this.isTouched = true
        }
      }
    },
    unfoldingTeamId: {
      get: function () {
        this.refreshKey
        return this.meal.unfoldingTeamId
      },
      set: function (value) {
        if (value !== this.meal.unfoldingTeamId) {
          this.meal.unfoldingTeamId = value

          if (this.$refs.assignTeamMealRow) {
            this.$refs.assignTeamMealRow.forEach((component) => {
              component.isBlocked = true
              component.unfoldingTeamId = this.meal.unfoldingTeamId
              component.isBlocked = false
            })
          }

          if (!this.isBlocked) {
            this.save('unfolding_team')
          }

          if (this.meal.kind === 'PK') {
            this.isDifferentUnfoldingTeam = this.isDifferentUnfoldingTeamMethod(this.meal, this.meal.unfoldingTeamId)
          }

          this.refreshKey++
          this.isTouched = true
        }
      }
    },
    hour: {
      get: function () {
        this.refreshKey
        return this.meal.hour
      },
      set: function (value) {
        if (value !== this.meal.hour) {
          this.meal.hour = value

          if (this.$refs.assignTeamMealRow) {
            this.$refs.assignTeamMealRow.forEach((component) => {
              component.isBlocked = true
              component.hour = this.meal.hour
              component.isBlocked = false
            })
          }

          if (!this.isBlocked) {
            this.save('hour')
          }

          this.refreshKey++
        }
      }
    },
  },
  methods: {
    componentsAssignTeam(args) {
      if (this.meal.kind === 'PK') {
        this.isDifferentTeam = this.isDifferentTeamMethod(this.meal, this.meal.teamId)
        this.isDifferentUnfoldingTeam = this.isDifferentUnfoldingTeamMethod(this.meal, this.meal.unfoldingTeamId)
        this.isDifferentDate = this.isDifferentDateMethod(this.meal, this.meal.productionDate)
      }

      this.$emit('assingteam', args)
    },
    changeDate(value) {
      if (value !== this.productionDate) {
        this.productionDate = value
      }
    },
    clearDate() {
      if (value !== this.productionDate) {
        this.productionDate = value
      }
    },
    isDifferentTeamMethod(meal, teamId) {
      if (meal.teamId !== teamId) {
        return true
      }
      for (let i = 0; i < meal.components.length; i++) {
        if (this.isDifferentTeamMethod(meal.components[i], teamId)) {
          return true
        }
      }
      return false
    },
    isDifferentUnfoldingTeamMethod(meal, unfoldingTeamId) {
      if (meal.unfoldingTeamId !== unfoldingTeamId) {
        return true
      }
      for (let i = 0; i < meal.components.length; i++) {
        if (this.isDifferentUnfoldingTeamMethod(meal.components[i], unfoldingTeamId)) {
          return true
        }
      }
      return false
    },
    isDifferentDateMethod(meal, date) {
      if (DateHelper.format(meal.productionDate) !== DateHelper.format(date)) {
        return true
      }
      for (let i = 0; i < meal.components.length; i++) {
        if (this.isDifferentDateMethod(meal.components[i], date)) {
          return true
        }
      }
      return false
    },
    expand() {
      if (!this.isExpandAll) {
        this.expandAll()
      } else {
        this.collapseAll()
      }
    },
    expandAll() {
      this.showComponents = true
      if (this.$refs.assignTeamMealRow) {
        this.$refs.assignTeamMealRow.forEach((component) => {
          component.expandAll()
        })
      }
    },
    collapseAll() {
      this.showComponents = false
      if (this.$refs.assignTeamMealRow) {
        this.$refs.assignTeamMealRow.forEach((component) => {
          component.collapseAll()
        })
      }
    },
    save(type) {
      this.$emit('assingteam', {
        teamId: this.meal.teamId,
        unfoldingTeamId: this.meal.unfoldingTeamId,
        productionDate: this.meal.productionDate,
        mealId: this.meal.mealId,
        finalMealId: this.meal.finalMealId,
        uid: this.meal.uid,
        hour: this.meal.hour,
        type: type,
      })
    }
  },
}
</script>

<style scoped>
.main {
  border-bottom: 1px solid #e8e8e8;
  margin-bottom: 10px;
}

.col-md-1 {
  text-align: right;
  font-size: 2.5rem;
}

.col-md-1 > span {
  cursor: pointer;
}

.link-edit-pk {
  margin: 15px 10px 0 0;
  color: #659be0;
}

.link-edit-pk:link {
  text-decoration: none;
}

.link-edit-pk:hover {
  text-decoration: none;
  color: #7caeef
}
</style>
